import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { MessageService } from '@core/errors/messages-service';
import { getErrorCode } from '@core/utils/get-error-code';
import { environment } from '@environment';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '../../../../@fuse/components/confirm-dialog/confirm-dialog.service';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
import { QuotationService } from '../services/quotation.service';
import { DialogUpdatedComponent } from './dialog-updated/dialog-updated.component';
var DialogQuotationComponent = /** @class */ (function () {
    function DialogQuotationComponent(data, matDialogRef, fuseTranslationLoaderService, fuseProgressBarService, translateService, quotationService, messageService, authenticationService, matDialog, confirmDialogService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.translateService = translateService;
        this.quotationService = quotationService;
        this.messageService = messageService;
        this.authenticationService = authenticationService;
        this.matDialog = matDialog;
        this.confirmDialogService = confirmDialogService;
        this.reportUrl = environment.GROUND_BASE_URL + "/#/orcamentos/";
        this.refreshDatatable = false;
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
        this.quotation = data.quotation;
        this.isViewMode = data.isViewMode;
        this.hasFeatureApproveQuotationByPanel = data.hasFeatureApproveQuotationByPanel;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogQuotationComponent.prototype.ngOnDestroy = function () {
        this.matDialogRef.close({ reload: this.refreshDatatable });
    };
    DialogQuotationComponent.prototype.executeAction = function (action) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var actionUpperCased, result, input, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionUpperCased = action.toUpperCase();
                        return [4 /*yield*/, this.confirmDialogService.open({
                                title: this.translateService.instant("QUOTATIONS.CONFIRM.TITLE_" + actionUpperCased),
                                message: this.translateService.instant("QUOTATIONS.CONFIRM.MESSAGE_" + actionUpperCased),
                                okText: this.translateService.instant("QUOTATIONS.CONFIRM.CONTINUE_AND_" + actionUpperCased),
                                cancelText: this.translateService.instant('QUOTATIONS.CONFIRM.CANCEL_TEXT'),
                                inputLabel: this.translateService.instant('QUOTATIONS.CONFIRM.MESSAGE_PLACEHOLDER')
                            })];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, 10, 11]);
                        this.fuseProgressBarService.show();
                        input = {
                            id: this.quotation.id,
                            updatedAt: this.quotation.updatedAt,
                            approvedMessage: result.message
                        };
                        if (!(action === 'approve')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.quotationService.approveQuotation(input)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.quotationService.rejectQuotation(input)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.messageService.success("QUOTATIONS.MESSAGES.SUCCESS_" + actionUpperCased, {
                            identifier: this.quotation.identifier
                        });
                        this.matDialogRef.close({ reload: true });
                        return [3 /*break*/, 11];
                    case 7:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (!(code === 'quotation_is_outdated')) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.updateOutdatedQuotation()];
                    case 8:
                        _a.sent();
                        return [2 /*return*/];
                    case 9:
                        this.messageService.error(err_1, 'QUOTATIONS.ERRORS.UNKNOWN_ERROR');
                        return [3 /*break*/, 11];
                    case 10:
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    DialogQuotationComponent.prototype.updateOutdatedQuotation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.matDialog.open(DialogUpdatedComponent, {
                            maxWidth: '380px'
                        }).afterClosed().toPromise()];
                    case 1:
                        _b.sent();
                        this.fuseProgressBarService.show();
                        _a = this;
                        return [4 /*yield*/, this.quotationService.getById(this.quotation.id)];
                    case 2:
                        _a.quotation = _b.sent();
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogQuotationComponent.prototype.wasUpdatedLabels = function () {
        this.refreshDatatable = true;
    };
    return DialogQuotationComponent;
}());
export { DialogQuotationComponent };
